import React from "react";
import { useContent } from "../hooks/useContent";
import { useLang } from "../context/LanguageContext";
import { SEO } from "../components/SEO";
import { PageHeader } from "../components/PageHeader";
import { ProjectCard } from "../components/cards/ProjectCard";
import { Stagger, StaggerItem, Reveal } from "../components/motion/Reveal";
import { CTASection } from "../components/home/FinancialBenefits";

export default function Projects() {
  const { t } = useLang();
  const { data: projects } = useContent("projects");

  return (
    <>
      <SEO pageKey="projects" title={t.seo.projects.title} description={t.seo.projects.description} />
      <PageHeader pageKey="projects"
        overline={t.projects.overline}
        title={t.projects.title}
        sub={t.projects.sub}
        image="https://images.unsplash.com/photo-1694974249671-2a921a644a1c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000"
      />
      <section className="py-10 sm:py-14 bg-white">
        <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
          <Stagger className="grid grid-cols-2 lg:grid-cols-3 gap-0">
            {projects.map((p, i) => (
              <StaggerItem key={p.id || p.slug}>
                <ProjectCard project={p} index={i} />
              </StaggerItem>
            ))}
          </Stagger>
          {!projects.length && <Reveal><p className="text-center text-charcoal/50 py-20" data-testid="projects-loading">{t.common.loading}</p></Reveal>}
        </div>
      </section>
      <CTASection />
    </>
  );
}
